import styles from "./historyTabs.module.scss";

interface HistoryTabsProps {
  showActiveTab: boolean;
  onTabChange: (showActive: boolean) => void;
}

export function HistoryTabs({ showActiveTab, onTabChange }: HistoryTabsProps) {
  return (
    <div className={styles.container}>
      <button
        onClick={() => onTabChange(false)}
        className={`${styles.tab}${!showActiveTab ? ` ${styles.tabActive}` : ""}`}
      >
        Завершенные
      </button>
      <button
        onClick={() => onTabChange(true)}
        className={`${styles.tab}${showActiveTab ? ` ${styles.tabActive}` : ""}`}
      >
        Активные
      </button>
    </div>
  );
}

